// extracted by mini-css-extract-plugin
module.exports = {"donation":"lT","donationIcon":"lU","donationTitle":"lV"};